module.exports = __webpack_public_path__ + "static/media/img1.9933f1a6.jpg";